import { render } from "./AchievementDetailReport.vue?vue&type=template&id=99903dfc"
import script from "./AchievementDetailReport.vue?vue&type=script&lang=js"
export * from "./AchievementDetailReport.vue?vue&type=script&lang=js"

import "./AchievementDetailReport.vue?vue&type=style&index=0&id=99903dfc&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__